import { render, staticRenderFns } from "./ProjectCostPerformance.vue?vue&type=template&id=8761e15e&scoped=true"
import script from "./ProjectCostPerformance.vue?vue&type=script&lang=ts"
export * from "./ProjectCostPerformance.vue?vue&type=script&lang=ts"
import style0 from "./ProjectCostPerformance.vue?vue&type=style&index=0&id=8761e15e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8761e15e",
  null
  
)

export default component.exports